/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Client_Edit_TitleInputs */

const cs_client_edit_title = /** @type {(inputs: Client_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upravit klienta`)
};

const en_client_edit_title = /** @type {(inputs: Client_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit client`)
};

/**
* | output |
* | --- |
* | "Edit client" |
*
* @param {Client_Edit_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const client_edit_title = /** @type {((inputs?: Client_Edit_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Client_Edit_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_client_edit_title(inputs)
	return cs_client_edit_title(inputs)
});